<template>
  <div class="Others22Charts" :class="getStyle('Style')">
    <div
      class="fp-flex"
      :style="{
        padding: 6 + getShowNumberSize() + 'px',
      }"
    >
      <div
        :style="{
          width: 120 + getShowNumberSize() + 'px',
          marginRight: '14px',
        }"
      >
        <img
          :style="{
            width: 120 + getShowNumberSize() + 'px',
          }"
          :src="imageSrc"
        />
      </div>
      <div class="fp-r">
        <div
          class="title"
          :style="{
            padding: `${1 + getShowNumberSize()}px  0`,
            fontSize: `${fontStyle.innerTitleSize}px`,
            color: `${fontStyle.innerTitleColor}`,
          }"
        >
          <span>{{ Configuration.propertyData?.smallTitlText?.value }}</span>
          <div style="display: flex; align-items: flex-end; margin-left: 8px">
            <span v-html="formatText(fpdataone)"></span>
            <img
              src="../../../assets/img/other_1.png"
              class="ml-1"
              v-if="fpdataone && fpdataone.trim() !== ''"
            />
          </div>
          <div style="display: flex; align-items: flex-end; margin-left: 8px">
            <span v-html="formatTou(fpdatatuo)"></span>
            <img
              src="../../../assets/img/other_2.png"
              class="ml-1"
              v-if="fpdatatuo && fpdatatuo.trim() !== ''"
            />
          </div>
        </div>
        <div
          class="fp-container new-laye"
          :style="{
            left: 50 + getShowNumberSize() + '%',
          }"
        >
          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-bk"></div>

            <div
              class="nums-container"
              :style="`transform: translateY(-${fp.num6}00%)`"
              :class="{ 'nums-container-transition': animationFlag }"
            >
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>0</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>1</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>2</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>3</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>4</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>5</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>6</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>7</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>8</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>9</div>
              </div>
            </div>
          </div>

          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-container">
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>,</div>
              </div>
            </div>
          </div>

          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-bk"></div>

            <div
              class="nums-container"
              :style="`transform: translateY(-${fp.num5}00%)`"
              :class="{ 'nums-container-transition': animationFlag }"
            >
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>0</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>1</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>2</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>3</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>4</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>5</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>6</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>7</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>8</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>9</div>
              </div>
            </div>
          </div>

          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-bk"></div>

            <div
              class="nums-container"
              :style="`transform: translateY(-${fp.num4}00%)`"
              :class="{ 'nums-container-transition': animationFlag }"
            >
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>0</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>1</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>2</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>3</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>4</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>5</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>6</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>7</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>8</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>9</div>
              </div>
            </div>
          </div>

          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-bk"></div>

            <div
              class="nums-container"
              :style="`transform: translateY(-${fp.num3}00%)`"
              :class="{ 'nums-container-transition': animationFlag }"
            >
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>0</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>1</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>2</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>3</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>4</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>5</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>6</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>7</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>8</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>9</div>
              </div>
            </div>
          </div>

          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-container">
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>,</div>
              </div>
            </div>
          </div>

          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-bk"></div>

            <div
              class="nums-container"
              :style="`transform: translateY(-${fp.num2}00%)`"
              :class="{ 'nums-container-transition': animationFlag }"
            >
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>0</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>1</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>2</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>3</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>4</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>5</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>6</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>7</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>8</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>9</div>
              </div>
            </div>
          </div>

          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-bk"></div>

            <div
              class="nums-container"
              :style="`transform: translateY(-${fp.num1}00%)`"
              :class="{ 'nums-container-transition': animationFlag }"
            >
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>0</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>1</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>2</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>3</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>4</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>5</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>6</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>7</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>8</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>9</div>
              </div>
            </div>
          </div>

          <div
            class="nums-item-show-box"
            :style="{
              marginRight: 0,
            }"
          >
            <div class="nums-bk"></div>

            <div
              class="nums-container"
              :style="`transform: translateY(-${fp.num0}00%)`"
              :class="{ 'nums-container-transition': animationFlag }"
            >
              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>0</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>1</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>2</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>3</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>4</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>5</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>6</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>7</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>8</div>
              </div>

              <div
                class="nums-rolling-item"
                :style="{
                  fontSize: `${fontStyle.innerTitleSize} px`,
                  color: chartColor[0],
                }"
              >
                <div>9</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getFilterValue } from '../../../utils/tool';
import { request } from '../../../common/request';
export default {
  name: 'Others22Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      fp: {
        num0: 0,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        num6: 0,
      },
      animationFlag: false, // 控制是否用动画
      timeId: null,
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID2: null,
      staticIntervalTaskID: null,
      apiStaticIntervalTaskID: null,
      chartColor: {},
      rotateNumber: 18212,
      scaleratio: 1,
      orderNum: ['0', ',', '0', '0', '0', ',', '0', '0', '0'], // 默认订单总数
      currentNumber: 0, // 记录上一次请求的值
      flipCardicon: { model: 'ione1' },
      fpdataone: '',
      fpdatatuo: '',
      fontStyle: {},
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function(val) {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
        this.flipCardicon = val.propertyData?.flipCardicon?.value;
      },
    },
    dataContainer: {
      deep: true,
      handler: function(nV) {
        if (this.Configuration.propertyData.ChartsData.value.stateData.isUseStateData) {
          this.setEchartsOptions();
        }
      },
    },
  },
  // created() {
  //   clearInterval(this.apiIntervalTaskID);
  //   clearInterval(this.staticIntervalTaskID);
  //   clearInterval(this.staticIntervalTaskID2);
  //   this.registerDebounceAndThrottle();
  // },
  mounted() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
    this.flipCardicon = this.Configuration.propertyData?.flipCardicon?.value;
    // 不用
    // setInterval(() => {
    //   this.setShowNumber(this.currentNumber);
    //   this.currentNumber++;
    // }, 300);
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    clearInterval(this.apiStaticIntervalTaskID);

    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
    fontStyle() {
      return (
        this.Configuration.propertyData.fontStyle.value || {
          innerTitleSize: 16,
          innerTitleColor: '#fff',
        }
      );
    },
    imageSrc() {
      return require(`@/assets/img/fpione/${this.flipCardicon?.model}.png`);
    },
    ...mapState({
      dataContainer: state => state.dataContainer,
    }),
  },
  methods: {
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    formatText(text) {
      const regex = /(\d+(\.\d+)?)/g;
      return text.replace(regex, '<span style="color: #fa1414;"> $1 </span>');
    },
    formatTou(text) {
      const regex = /(\d+(\.\d+)?)/g;
      return text.replace(regex, '<span style="color: #4effb2;"> $1 </span>');
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        case 'V12Style':
          if (bool) style['V12StyleTitle'] = true;
          style['V12Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    setShowNumber(nums) {
      console.log(nums, 'nums');
      // let history = null;
      console.log('nums nums', nums);
      // console.log('history', history);
      if (typeof nums === 'number' && nums <= 9999999 && nums >= 0) {
        this.fp.num6 = Math.floor(nums / 1000000);
        this.fp.num5 = Math.floor((nums % 1000000) / 100000);
        this.fp.num4 = Math.floor(((nums % 1000000) % 100000) / 10000);
        this.fp.num3 = Math.floor((((nums % 1000000) % 100000) % 10000) / 1000);
        this.fp.num2 = Math.floor(((((nums % 1000000) % 100000) % 10000) % 1000) / 100);
        this.fp.num1 = Math.floor((((((nums % 1000000) % 100000) % 10000) % 1000) % 100) / 10);
        this.fp.num0 = Math.floor(((((((nums % 1000000) % 100000) % 10000) % 1000) % 100) % 10) / 1);
      } else {
        // this.$message.warning('数字溢出，显示异常，请联系客服');
        // this.fp = {
        //   num0: 0,
        //   num1: 0,
        //   num2: 0,
        //   num3: 0,
        //   num4: 0,
        //   num5: 0,
        //   num6: 0,
        // };
      }
      // history = nums;
    },
    getShowNumberSize() {
      // console.log('-------------------------');
      let sc = Math.round(this.Configuration.style.height / 20);
      return sc;
    },
    getChartWidth() {
      return this.Configuration.style.width;
    },
    getChartHeight() {
      return this.Configuration.style.height;
    },
    // 设置文字滚动
    toOrderNum(num) {
      num = num.toString(); // 把订单数变成字符串
      if (num.length < 7) {
        num = '0' + num; // 如未满八位数，添加"0"补位
        this.toOrderNum(num); // 递归添加"0"补位
      } else if (num.length === 7) {
        // 订单数中加入逗号
        num = num.slice(0, 1) + ',' + num.slice(1, 4) + ',' + num.slice(4, 7);
        this.orderNum = num.split(''); // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过八位显示异常
        this.$message.warning('订单总量数字过大，显示异常，请联系客服');
      }
    },
    // 随机数
    randomNum(minNum, maxNum) {
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    },

    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      clearInterval(this.apiStaticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
      this.getShowNumberSize();

      if (this?.Configuration?.propertyData?.scaleratio.value) {
        this.scaleratio = parseFloat(this?.Configuration?.propertyData?.scaleratio.value);
      }
    },
    setEchartsOptions(ParamData = null) {
      // this.rotateNumber = 0;
      // this.setShowNumber(this.rotateNumber);
      this.chartColor = {};
      this.fpdataone = '';
      this.fpdatatuo = '';
      this.fontStyle = {};
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      let stateData = {};
      if (this.Configuration.propertyData.ChartsData.value.stateData) {
        stateData = this.Configuration.propertyData.ChartsData.value.stateData;
      }

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        this.fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData.fpdataone.value) {
        this.fpdataone = this.Configuration.propertyData.fpdataone.value;
      }
      if (this.Configuration.propertyData.fpdatatuo.value) {
        this.fpdatatuo = this.Configuration.propertyData.fpdatatuo.value;
      }

      console.log(source, '2342342342');
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      this.chartColor = chartColor;

      let xData = [];
      let yData = [];
      let xyData = [];
      let unit = '';

      function DealData() {
        seriesList.forEach(s => {
          source.forEach((item, index) => {
            if (s === item.s) {
              unit = item.s;
              if (index >= 4) return;
              xData.push(item.x);
              yData.push(item.y);

              xyData.push({
                name: item.x,
                value: parseInt(item.y),
              });
            }
          });
        });
      }
      DealData();

      if (stateData?.isUseStateData) {
        this.rotateNumber = this.$store.state.dataContainer[stateData.dataPot].reduce((pre, cur) => {
          pre += cur;
          return pre;
        }, 0);
        if (typeof this.rotateNumber == 'number' && this.rotateNumber.toString() != 'NaN') {
          this.currentNumber = this.rotateNumber;
        }

        this.setShowNumber(this.currentNumber);
      } else {
        this.rotateNumber = Number(yData[0]);
        if (typeof this.rotateNumber == 'number' && this.rotateNumber.toString() != 'NaN') {
          this.currentNumber = this.rotateNumber;
        }
        this.setShowNumber(this.currentNumber);
      }
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);
          this.animationFlag = false;
          this.setShowNumber(0);
          setTimeout(() => {
            this.animationFlag = true;
            this.setEchartsOptions(data);
          }, 0);
        };
        clearInterval(this.staticIntervalTaskID);
        func();
        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };

        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);

        // 动态请求 静态刷新
        let funcStatic = () => {
          this.animationFlag = false;
          this.setShowNumber(0);
          setTimeout(() => {
            this.animationFlag = true;
            this.setShowNumber(this.currentNumber);
          }, 0);

          // 设置值
        };
        clearInterval(this.apiStaticIntervalTaskID);
        funcStatic();
        this.apiStaticIntervalTaskID = setInterval(() => {
          funcStatic();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'apiData') {
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }

            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function(data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            console.log(arryQuery, 'getApiDataRes 11 res ------');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '图标翻牌器',
    componentName: 'Others22Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others22Charts.png',
    id: '',
    style: {
      width: 400,
      height: 167,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      scaleratio: {
        value: 1,
        lable: '组件缩放倍数',
        propertyComponentName: 'SingleInputor',
      },
      smallTitlText: {
        value: '图表标题',
        lable: '内标题',
        propertyComponentName: 'SingleInputor',
      },
      fpdataone: {
        value: '图表数1',
        lable: '数据1',
        propertyComponentName: 'SingleInputor',
      },
      fpdatatuo: {
        value: '图表数据2',
        lable: '数据2',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
            apiPostParams: '',
            apiHeader: '',
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                y: '122',
                x: '2021-06-02',
              },
            ],
          },
          // vuex数据
          stateData: {
            isUseStateData: true, // 是否使用vuex数据
            dataPot: 'data1', // 数据容器
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          // 内部标题
          innerTitleSize: 16,
          innerTitleColor: '#fff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        // propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      flipCardicon: {
        propertyComponentName: 'FlipCardiconConfiger',
        value: {
          model: 'ione1',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.Others22Charts {
  color: white;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .fp-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-items: center;
    /* width: 90%; */
    height: 100%;
    position: relative;
  }
  .fp-r {
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &::after {
      display: none;
    }
    .ml-1 {
      margin-left: 4px;
      width: 12%;
    }
  }
  .new-laye {
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-mask-image: -webkit-radial-gradient(white, black);
  }
  .fp-container {
    width: 100%;
    height: 46%;
    max-height: 80px;
    display: flex;
    overflow: hidden;
    .nums-item-show-box {
      margin: 0 5px;
      position: relative;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 30px;
      .nums-bk {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background-image: linear-gradient(to bottom, #0a234d, #0e3c82);
        border: 1px #1e7bd6 solid;
        border-radius: 6px;
      }

      .nums-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        .nums-rolling-item {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          div {
            font-size: 1.6em;
            font-weight: bold;
            white-space: nowrap;
            /* color: rgb(159, 220, 255); */
          }
        }
      }

      .nums-container-transition {
        transition: all 1s ease-in-out;
      }
    }
  }

  .V5StyleTitle {
    color: #0ee59b;
    font-weight: bold;
  }
  /* 空谷幽兰 */
  .V1Style {
    background: none !important;
    .nums-item-show-box {
      .nums-bk {
        background-image: linear-gradient(
          to bottom,
          rgba(22, 77, 108, 0.582),
          rgba(1, 11, 32, 0.541)
        ) !important;
        border: 1px #147ee0 solid !important;
        border-radius: 6px;
      }

      .nums-rolling-item {
        div {
          padding: 10px 0;
          background: linear-gradient(to bottom, #fff, #fff 50%, #b5cbdf 10%);
          -webkit-text-fill-color: transparent;
          -webkit-background-clip: text;
          background-clip: text;
        }
      }
    }
  }
  /* 只此青蓝 */
  .V2Style {
    background: none !important;
    .nums-item-show-box {
      .nums-bk {
        background-image: linear-gradient(
          to bottom,
          rgba(10, 88, 57, 0.541),
          rgba(1, 32, 11, 0.541)
        ) !important;
        border: 1px #74c5a2 solid !important;
        border-radius: 6px;
      }

      .nums-rolling-item {
        div {
          padding: 10px 0;
          background: linear-gradient(to bottom, #fff, #fff 50%, #698b75 10%);
          -webkit-text-fill-color: transparent;
          -webkit-background-clip: text;
          background-clip: text;
        }
      }
    }
  }

  /* 绿野仙踪 */
  .V5Style,
  .V10Style {
    // 背景去掉
    background: none !important;
    .nums-item-show-box {
      .nums-bk {
        background-image: linear-gradient(to bottom, rgba(65, 118, 94, 0.54), rgba(0, 27, 24)) !important;
        border: 1px #00a716 solid !important;
        border-radius: 6px;
      }
      .nums-rolling-item {
        div {
          padding: 10px 0;
          background: linear-gradient(to bottom, #fff, #fff 50%, #8bff99 10%);
          -webkit-text-fill-color: transparent;
          -webkit-background-clip: text;
          background-clip: text;
        }
      }
    }
  }

  /* 紫气东来 */
  .V4Style {
    background: none !important;
    .nums-item-show-box {
      .nums-bk {
        background-image: radial-gradient(circle, transparent, #b395b94f) !important;
        // background-image: linear-gradient(180deg, #0ab54e83, #0ab54e83) !important;
        border: 1px #9d90df solid !important;
        border-radius: 6px;
      }

      .nums-rolling-item {
        div {
          color: #b1afff !important;
        }
      }
    }
  }
  /* 青绿时代 */
  .V6Style {
    background: none !important;
    .nums-item-show-box {
      .nums-bk {
        background-image: radial-gradient(circle, transparent, rgba(82, 82, 78)) !important;
        // background-image: linear-gradient(180deg, #0ab54e83, #0ab54e83) !important;
        border: 1px #d7d7d6 solid !important;
        border-radius: 6px;
      }

      .nums-rolling-item {
        div {
          color: #d7d5ba !important;
        }
      }
    }
  }
  /* 青云雅韵 */
  .V8Style {
    background: none !important;
    .nums-item-show-box {
      .nums-bk {
        background-image: radial-gradient(circle, transparent, rgba(237, 237, 209)) !important;
        // background-image: linear-gradient(180deg, #0ab54e83, #0ab54e83) !important;
        border: 1px #c1c1b9 solid !important;
        border-radius: 6px;
      }

      .nums-rolling-item {
        div {
          color: #a19f67 !important;
        }
      }
    }
  }

  /* blue */
  .V3Style,
  /* .V6Style, */
  .V7Style,
  .V9Style {
    background: none !important;
    .nums-item-show-box {
      .nums-bk {
        background-image: linear-gradient(
          to bottom,
          rgba(30, 94, 231, 0.582),
          rgba(1, 11, 32, 0.541)
        ) !important;
        border: 1px #24c3ff solid !important;
        border-radius: 6px;
      }

      .nums-rolling-item {
        div {
          padding: 10px 0;
          background: linear-gradient(to bottom, #fff, #fff 50%, #8beaff 10%);
          -webkit-text-fill-color: transparent;
          -webkit-background-clip: text;
          background-clip: text;
        }
      }
    }
  }
}

.V11Style {
  background: none !important;
  .nums-item-show-box {
    .nums-bk {
      background-image: linear-gradient(to bottom, #28110794, #28110794) !important;
      border: 1px #8a2723 solid !important;
      border-radius: 6px;
    }

    .nums-rolling-item {
      div {
        padding: 10px 0;
        color: rgb(255 255 255);
        background: linear-gradient(to bottom, #fff, #fff 50%, #e8ab55 10%);
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text;
        background-clip: text;
      }
    }
  }
}
@media screen and (max-width: 786px) {
  .nums-item-show-box {
    min-width: 18px !important;
  }
}
</style>
